// Bottom toast install prompt — Android (beforeinstallprompt) and iOS (manual instructions)

import { Trans, useTranslation } from 'react-i18next'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'

export function InstallPrompt() {
  const { t } = useTranslation()
  const { showAndroidPrompt, showIOSPrompt, installApp, dismissPermanently } = useInstallPrompt()

  if (showAndroidPrompt) {
    return (
      <div className="fixed bottom-20 left-4 right-4 bg-card border border-border rounded-lg shadow-lg p-4 z-40">
        <p className="text-sm text-foreground mb-3">
          {t('pwa.install.androidMessage')}
        </p>
        <div className="flex gap-2 justify-end">
          <button
            onClick={dismissPermanently}
            className="text-sm text-muted-foreground px-3 py-1"
          >
            {t('pwa.install.notNow')}
          </button>
          <button
            onClick={installApp}
            className="text-sm bg-primary text-primary-foreground px-3 py-1 rounded-md"
          >
            {t('pwa.install.install')}
          </button>
        </div>
      </div>
    )
  }

  if (showIOSPrompt) {
    return (
      <div className="fixed bottom-20 left-4 right-4 bg-card border border-border rounded-lg shadow-lg p-4 z-40">
        <p className="text-sm text-foreground mb-1">
          {t('pwa.install.iosMessage')}
        </p>
        <p className="text-sm text-muted-foreground mb-3">
          <Trans i18nKey="pwa.install.iosInstructions" components={{ 1: <strong />, 3: <strong /> }} />
        </p>
        <div className="flex justify-end">
          <button
            onClick={dismissPermanently}
            className="text-sm text-muted-foreground px-3 py-1"
          >
            {t('pwa.install.dismiss')}
          </button>
        </div>
      </div>
    )
  }

  return null
}
